@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/shared/components/glass-house-brands/glass-house-header-quantity-and-price/glass-house-header-quantity-and-price.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: contents;
}
:host .glass-house-header-quantity-and-price {
  display: grid;
  background: #9f9f9f;
  border: 1px solid #9f9f9f;
  gap: 1px;
  align-content: start;
}
:host .glass-house-header-quantity-and-price ::ng-deep * {
  background: white;
}
:host .glass-house-header-quantity-and-price {
  border: unset;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  text-transform: uppercase;
  text-align: center;
  font-family: onest, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.75rem;
  line-height: 100%;
  letter-spacing: 1.92px;
}
:host .glass-house-header-quantity-and-price .glass-house-header-quantity {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
:host .glass-house-header-quantity-and-price .glass-house-header-price {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=glass-house-header-quantity-and-price.component.css.map */
